import { formatDate } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { WarehousingAbnormalService } from '../../../services/warehousing-abnormal.service';
import { WarehousingSearchService } from '../../../services/warehousing-search.service';

interface ImportWarehousingDetailAndUpdateWarehousingAbnormalRequest {
  saveWarehousingAbnormalRequest: any;
  importWarehousingDetailRequest: any;
}

@Component({
  selector: 'laas-warehousing-abnormal-handling-for-pcsr',
  templateUrl: './warehousing-abnormal-handling-for-pcsr.component.html',
  styleUrls: ['./warehousing-abnormal-handling-for-pcsr.component.scss']
})
export class WarehousingAbnormalHandlingForPcsrComponent extends SessionBaseComponent implements OnInit {

  @Input() params: any;
  @Output() visibleChange: EventEmitter<any>;
  isVisible: boolean;

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  importForm!: FormGroup;
  importParams: any;
  hawbNo: string = '';
  deliveryOptions: any[] = [];

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private warehousingAbnormalService: WarehousingAbnormalService,
    private warehousingSearchService: WarehousingSearchService,
  ) {
    super(injector);
    this.isVisible = false;
    this.importParams = {
      whNoAbnormalSeqNoMappings: [],
      documentNum: null,
      failImportReason: null,
      remarks: null,
    };
    this.importForm = this.fb.group(this.importParams);
    this.visibleChange = new EventEmitter<any>();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log(`init-params= ${JSON.stringify(this.params)}`);
    this.importParams.whNoAbnormalSeqNoMappings = this.params.whNoAbnormalSeqNoMappings;
    this.deliveryOptions = this.params.deliveryOptions;
    this.hawbNo = this.params.hawbNo;
  }

  submitImportAd(event: any): void {
    console.log(`Start doing submitImportAd... \n`);
    const reason = this.importForm.value.failImportReason;
    const remark = this.importForm.value.remarks;

    if (!isNullOrEmpty(this.importForm.value.documentNum) && this.importForm.value.documentNum.length != 0) {
      /* 若填寫AD單號時，則需呼叫importDetail */
      this.loader.show();
      this.warehousingSearchService.verifyHawbNoWithBillOfLading({
        adList: this.importForm.value.documentNum,
        hawbNo: this.hawbNo,
      }).subscribe({
        next: (result: any) => {
          console.info(`verifyHawbNoWithBillOfLading-result=${JSON.stringify(result)}`);
          if (result.equalStatus) {
            this.importWarehousingDetailAndUpdateWarehousingAbnormal(reason, remark);
          } else {
            this.confirmationService.confirm({
              target: event.target,
              message: `AD與入倉單的提單不同，請確認是否繼續匯入？`,
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.importWarehousingDetailAndUpdateWarehousingAbnormal(reason, remark);
              },
              reject: () => {
                this.toastService.warn(result.warningMessage, true);
                this.confirmationService.close();
              }
            });
          }
        },
        error: (error: any) => {
          this.toastErrorMessage(error.error);
          this.loader.hide();
          return;
        },
        complete: () => {
          this.loader.hide();
        }
      });
      return;
    } else if (this.importForm.value.failImportReason) {
      /* 若有選擇無法匯入原因時，則需呼叫submitHandleCase */
      console.log(`Write reason: importParams=${JSON.stringify(this.importParams)}, this.importForm=${JSON.stringify(this.importForm.value)}`);
      this.loader.show();
      const apiList = this.importParams.whNoAbnormalSeqNoMappings.map(({ whNo, warehousingAbnormalSeqNo }: { whNo: string, warehousingAbnormalSeqNo: number }) => this.warehousingAbnormalService.updateWarehousingAbnormalAndStatusByPcsrWriteAdCannotBeImportedReason({
        whNo,
        userId: this.userProfile.userName,
        warehousingAbnormalSeqNo: warehousingAbnormalSeqNo,
        abnormalDetailRequests: [],
        isHandled: true,
        isNotified: null,
        pcsrReason: reason,
        pcsrRemark: remark,
      }, 2));
      combineLatest(apiList).subscribe({
        next: (result: any) => {
          /* 成功送出資料 */
          this.toastService.success('已送出無法匯入原因');
          this.dialogVisibleChange(event);
        },
        error: (error: any) => {
          /* 錯誤處理 */
          this.toastErrorMessage(error.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      });
      return;
    } else {
      this.toastErrorMessage("Please import AD or write fail reason");
    }
  }

  importWarehousingDetailAndUpdateWarehousingAbnormal(reason: string | null, remark: string | null): void {

    let documentNoList: string[] = this.importForm.get("documentNum")?.value;
    if (documentNoList != null && documentNoList.length > 0) {
      const trimmedDocumentNoList = documentNoList.map(doc => doc.trim());
      this.importForm.controls.documentNum.setValue(trimmedDocumentNoList);
    }

    console.log(`Import AD: importParams=${JSON.stringify(this.importParams)}, this.importForm=${JSON.stringify(this.importForm.value)}`);
    console.log(`whNoAbnormalSeqNoMappings=${JSON.stringify(this.importParams.whNoAbnormalSeqNoMappings)}`);
    const requestList: ImportWarehousingDetailAndUpdateWarehousingAbnormalRequest[] = this.buildImportWarehousingDetailAndUpdateWarehousingAbnormalRequest(this.importParams.whNoAbnormalSeqNoMappings ,reason ,remark);

    console.log(`whNoRequestMap=${JSON.stringify(requestList)}`);
    this.loader.show();
    this.warehousingAbnormalService.importWarehousingDetailAndUpdateWarehousingAbnormal(requestList, 1).subscribe({
      next: (result: any) => {
        /* 成功送出資料 */
        console.info(`result=${JSON.stringify(result)}`);
        this.toastService.success('匯入AD成功');

        this.dialogVisibleChange(false);
      },
      error: (error: any) => {
        /* 錯誤處理 */
        this.toastErrorMessage(error.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  buildImportWarehousingDetailAndUpdateWarehousingAbnormalRequest(whNoAbnormalSeqNoMappings: any[],reason: string | null,remark: string | null): ImportWarehousingDetailAndUpdateWarehousingAbnormalRequest[] {
    /* 不分是否異常，拿所有入倉單，建立whNoRequestMap */
    const trxDt = new Date();
    trxDt.setHours(0, 0, 0, 0);
    const trxDtTmp = formatDate(trxDt, 'yyyy/MM/dd', 'en-US');

    let requestList = new Array();

    for (let i = 0; i < whNoAbnormalSeqNoMappings.length; i++) {
      let { whNo, warehousingAbnormalSeqNo } = whNoAbnormalSeqNoMappings[i];
      let request: ImportWarehousingDetailAndUpdateWarehousingAbnormalRequest = {
        importWarehousingDetailRequest: {
          whNo,
          sourceType: "1",
          referenceKey: this.importForm.value.documentNum,
          trxDtTmp,
          trxAmount: "",
          pcsrDept: "0000000000",
          brand: "",
          trxDt,
          userId: this.userProfile.userName,
        }, saveWarehousingAbnormalRequest: {
          whNo,
          userId: this.userProfile.userName,
          warehousingAbnormalSeqNo: warehousingAbnormalSeqNo,
          abnormalDetailRequests: [],
          isHandled: true,
          isNotified: null,
          pcsrReason: reason,
          pcsrRemark: remark,
        }
      };
      requestList.push(request);
    }
    return requestList;
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

}
